import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import DateTimeFormats from "const/DateTimeFormats";
import React from "react";
import TaskRepeatEndTypes from "const/TaskRepeatEndTypes";
import Texts from "utils/Texts";
import moment from "moment";

const Explanation = (props) => {
  const {
    className,
    startDate,
    periodValue,
    periodType,
    endType,
    endAfterDate,
    endAfterRepetitions,
    occurrencesRemaining,
    duePeriodType,
    duePeriodValue
  } = props;

  const { messages } = useSelector(getTextsData);

  if (!periodValue || !periodType || !startDate) return null;

  const nextTaskStartDate = moment.utc(startDate).add(periodValue, periodType);

  const [textA, textB, textC, textD] = messages.taskRepetitionExplanation;

  return (
    <div className={className}>
      {[
        (endType === TaskRepeatEndTypes.DATE && endAfterDate && nextTaskStartDate.isSameOrAfter(moment(endAfterDate)))
          ? Texts.replaceVars(textA, { endAfterDate: moment(endAfterDate).format(DateTimeFormats.DATE_TEXT) })
          : Texts.replaceVars(textB, { nextTaskStartDate: nextTaskStartDate.format(DateTimeFormats.DATE_TEXT) }),

        !!duePeriodType && !!duePeriodValue && Texts.replaceVars(textC, {
          dueOnDate: moment(nextTaskStartDate).add(duePeriodValue, duePeriodType).format(DateTimeFormats.DATE_TEXT)
        }),
        endType === TaskRepeatEndTypes.OCCURRENCES && Texts.replaceVars(textD, {
          occurrencesRemaining: occurrencesRemaining || endAfterRepetitions || 0
        })
      ].filter(Boolean).join(" ")}
    </div>
  );
};

export default React.memo(Explanation);
